const LOAN_ACTION_IDS = {
    MANAGE_LEVERAGE_BUTTON: "manage-leverage-app-button"
} as const;

const GENERIC_TEST_IDS = {
    BALANCE_DISPLAY_MAX_BUTTON: "balance-display-max-button",
    REPAY_BUTTON: "repay-button",
    WITHDRAW_COLLATERAL_BUTTON: "withdraw-collateral-button"
} as const;

const LOAN_TEST_IDS = {} as const;

const PORTFOLIO_TEST_IDS = {} as const;

const VAULT_TEST_IDS = {} as const;

const LOOP_TEST_IDS = {
    LOOP_LEVERAGE_SLIDER: "loop-leverage-slider",
    MANUAL_WIND_CARD: "manual-wind-card"
} as const;

export const TEST_IDS = {
    ...LOAN_ACTION_IDS,
    ...LOAN_TEST_IDS,
    ...PORTFOLIO_TEST_IDS,
    ...VAULT_TEST_IDS,
    ...LOOP_TEST_IDS,
    ...GENERIC_TEST_IDS
} as const;

export { LOAN_TEST_IDS, PORTFOLIO_TEST_IDS, VAULT_TEST_IDS, LOOP_TEST_IDS, LOAN_ACTION_IDS };
